import { useState, useRef, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import MeetingAddNewModal from './crudModals/MeetingAddNewModal';
import { useCompactPortrait, usePageNavigation, useNavigationAction } from 'components/navigation/NavigationContext';

export default function AgendaToolbar({
  toggleColor,
  isNoSleep,
  toggleWakeOnScreen,
  editMode,
  setEditMode,
  getMeetings
}) {
  const { user: authUser } = useSelector((state) => state.auth);
  const compact = useCompactPortrait();
  const [open, setOpen] = useState(false);
  const [openAddMeetingKey, setOpenAddMeetingKey] = useState(0);
  const toggleRef = useRef(null);
  const modalRef  = useRef(null);

  useEffect(() => {
    if (!open) return;
    function onPointerDown(e) {
      if (modalRef.current  && modalRef.current.contains(e.target))  return;
      if (toggleRef.current && toggleRef.current.contains(e.target)) return;
      setOpen(false);
    }
    function onKeyDown(e) {
      if (e.key === 'Escape') setOpen(false);
    }
    document.addEventListener('pointerdown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('pointerdown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open]);

  const isOfficer = authUser?.user?.acl?.toLowerCase() === 'officer';
  usePageNavigation({
    preferredOrientation: 'portrait',
    primaryAction: isOfficer && editMode ? {
      label: 'Add Meeting', icon: 'bi-plus-circle',
      onClick: () => setOpenAddMeetingKey(previous => previous + 1),
    } : null,
  });
  useNavigationAction('tools', {
    label: 'Meeting Tools',
    icon: 'bi-tools',
    renderContent: ({ closeMore }) => (
      <div className="mobile-more-actions" onClick={event => {
        if (event.target.closest('button:not(:disabled)') && !event.target.closest('[data-mobile-modal]')) closeMore();
      }}>
        {renderTools()}
      </div>
    ),
  });

  const renderTools = () => (
    <>
            <button
              className="agenda-modal-item"
              onClick={() => {
                toast.info('Meetings reloaded!', { position: 'bottom-left' });
                getMeetings();
                setOpen(false);
              }}
            >
              <i className="bi bi-arrow-clockwise"></i>
              <span>Reload Meetings</span>
            </button>

            {isOfficer && (
              <>
                {editMode && <button
                  data-mobile-modal
                  className="agenda-modal-item"
                  onClick={() => {
                    setOpenAddMeetingKey((prev) => prev + 1);
                    setOpen(false);
                  }}
                >
                  <i className="bi bi-plus-circle"></i>
                  <span>Add Meeting</span>
                </button>}
                <button
                  className={`agenda-modal-item${editMode ? ' active' : ''}`}
                  onClick={() => { setEditMode(v => !v); setOpen(false); }}
                >
                  <i className="bi bi-pencil-square"></i>
                  <span>{editMode ? 'Disable Editing' : 'Enable Editing'}</span>
                </button>
              </>
            )}
    </>
  );

  return (
    <>
      <div ref={toggleRef} className="agenda-toolbar-fixed">
        <button
          className="agenda-toolbar-toggle"
          onClick={() => setOpen(v => !v)}
          aria-label="Toggle meetings tools"
        >
          <i className="bi bi-tools" />
        </button>
      </div>
      {!compact && open && (
        <>
          <div className="agenda-modal-overlay" onClick={() => setOpen(false)} />
          <div ref={modalRef} className="agenda-modal-popup">{renderTools()}</div>
        </>
      )}

      {isOfficer && (
        <MeetingAddNewModal
          navigationParent="tools"
          getMeetings={getMeetings}
          triggerMode="none"
          openKey={openAddMeetingKey}
        />
      )}
    </>
  );
}
